export const BUTTON_SIZE_DEFAULT_PX = '36px';
export const BUTTON_SIZE_SMALL_PX = '20px';
